// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__2s3zP","innerSpinner":"LoadingSpinner_innerSpinner__mW3Ih","spin":"LoadingSpinner_spin__3cknP"};